export enum OnlineOfflineStatusType {
  'offline' = 1,
  'online' = 2,
}

export interface OnlineOfflineStatus {
  status: OnlineOfflineStatusType;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/datastore/online-offline/online-offline.model.ts